module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Gamepad#1-39999e44f9af2d8d8426eee4d24898c2.svg";